var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button"},[_c('md-button',{class:_vm.dynamicClasses,attrs:{"md-ripple":_vm.ripple,"disabled":_vm.disabled}},[(_vm.loading)?[_c('nna-spinner')]:[_vm._t("default")]],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5348118a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../nonameapp-common-modules/src/components/Button/Button.vue
// module id = null
// module chunks = 